import cloneDeep from 'lodash-es/cloneDeep';
import lookAndFeel from '../lookAndFeel';
import updateStyleByRef from '../css/updateStyleByRef';
import updateClass from '../css/updateClass';
import 'nouislider/distribute/nouislider.css';

const cssClass = [
  {
    selector: '.noUi-origin',
    properties: {
      display: 'none'
    },
  },
  {
    selector: '.noUi-connects',
    properties: {
      pointerEvents:'none'
    },
  },
];



export default {
  cssClass,
  init: () => {
    // console.log('.io-progress-default');
    updateClass(
      'io-progress-default-style',
      updateStyleByRef(cloneDeep(cssClass), lookAndFeel()),
      '.io-progress-default'
    );
  }
};
